var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showNotice)?_c('marquee',[_c('div',{staticClass:"downtime-notice"},[_c('span',{staticClass:"material-icons"},[_vm._v("info")]),_c('span',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }